import ServiceApi from "../services/service.api";

const baseServiceUrl = `/api/v1/PromoCode`;



const PromoCode = {
  getAll: (params) => {
    const url = `${baseServiceUrl}`;
    return ServiceApi.get(url, { params });
  },
  get: (id) => {
    const url = `${baseServiceUrl}/${id}`;
    return ServiceApi.get(url);
  },
  getAllPromoCategory: (params) => {
    const url = `${baseServiceUrl}/getAllPromoCategory`;
    return ServiceApi.get(url, { params });
  },
  getAgentById: (params) => {
    const url = `${baseServiceUrl}/getAgentById?id=` + params;
    return ServiceApi.get(url, { params });
  },
  createandEditPromoCode: (params) => {
    const url = `${baseServiceUrl}/addOrEditPromoCode`;
    return ServiceApi.post(url, params);
  },
  getNewPromoCodeQuery: () => {
    const url = `${baseServiceUrl}/getNewPromoCodeQuery`;
    return ServiceApi.get(url);
  },
  removePromoCodeUser: (params) => {

    const url = `${baseServiceUrl}/RemovePromoCodeUser`;

    return ServiceApi.put(url, params);
  },

  getPromoCode: (params) => {
    const url = `${baseServiceUrl}/GetPromoCode`;
    return ServiceApi.get(url, { params });
  },
};

export default PromoCode;


